export default {
  'InvoiceNumber': {
    label: 'Invoice',
    uid: 'PaymentInvoiceID',
    uri: '#/i/Invoices/sent/?goto=InvoiceDetail/{{id}}/0/payment-list-receive',
    onclick: 'setCookie("from_tab", "SentInvoices", "/")',
    width: 190
  },

  'PONumber': {
    label: 'PO',
    width: 180
  },

  'ClientName': {
    label: 'Client',
    uid: 'PoSenderVci',
    uri: '#/i/Invoices/Profile{{id}}-{{screen}}',
    tooltip: 'View profile of {{text}}'
  },

  'PaymentMethodForSupplier': {
    label: 'Payment Method',
    source: 'PaymentList_PaymentsReceived'
  },

  'PaymentStatus': {
    label: 'Payment Status',
    source: 'PaymentList_PaymentsReceived'
    // render: statuses,
    // width: 270
  },

  'DueDateFormatted': 'Due',
  'DueDate': '_',
  'EstimatedPaymentDateFormatted': {
    label: 'Estimated Payment Date',
    nowrap: false
  },

  'Amount': 'Amount',

  'BatchID': {
    label: 'Batch #',
    visible: false
  },
  'CreatedBy': {
    label: 'Created By',
    visible: false
  },
  'CreatedByName': {
    label: 'Created By Name',
    visible: false
  },
  'UsageFeeWithMarketing': {
    label: 'Merchant Fee Amount',
    visible: false
  },
  'UsagePercentWithMarketing': {
    label: 'Merchant Fee %',
    type: 'percent',
    visible: false
  },
  'NetAmountAfterFees': {
    label: 'Net Amount After Fees',
    visible: false
  },
  'ProcessedDateFormatted': {
    label: 'Payment Processed Date',
    visible: false
  },
  'IsPostPayment': {
    label: 'Process Method',
    compose: ProcessMethod,
    visible: false
  },
  'ProcessFee': {
    label: 'Processing Fee Amount',
    visible: false
  },
  'CcPercent': {
    label: 'Processing Fee %',
    type: 'percent',
    visible: false
  },
  'ReferenceNo': {
    label: 'Reference ID',
    visible: false
  },
  'RejectedDateFormatted': {
    label: 'Rejected Date',
    visible: false
  },
  'RejectedReason': {
    label: 'Rejected Reason',
    source: 'PaymentList_PaymentsReceived',
    visible: false
  },
  'RushPaymentReason': {
    label: 'Rush Payment Reason',
    visible: false
  },
  'PaymentDate': '_',
  'PaymentDateFormatted': {
    label: 'Scheduled Payment Date',
    visible: false
  },
  'SupplierIDCode': {
    label: 'Supplier ID',
    visible: false
  },
  'WithholdingTaxAmount': {
    label: 'Withholding Tax',
    visible: false
  }
}

function ProcessMethod(p) {
  return p.data.IsPostPayment ? 'Posted' : 'Processed'
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Invoice-payments-received/model.js